<div class="wrapper">
  <div class="d-flex flex-row align-items-center w-100 dialog-title">
    <div class="d-flex justify-content-center w-100">
      <h2 class="my-3" mat-dialog-title>Register</h2>
    </div>
    <mat-icon [mat-dialog-close]="true" class="material-symbols-outlined close">close</mat-icon>
  </div>
  @if (!errorMessage && success) {
    <div class="p-4">
      <span class="text-center">{{successMessage}}</span>
    </div>
  } @else {
    <form [formGroup]="registerForm" class="pb-3">
      <div class="d-flex flex-column justify-content-center align-items-center px-2 px-sm-5">
        <mat-form-field class="mt-4">
          <input type="text"
            placeholder="First Name"
            aria-label="First name"
            matInput
            formControlName="firstName"
            required>
          </mat-form-field>
          <mat-form-field class="">
            <input type="text"
              placeholder="Last Name"
              aria-label="Last name"
              matInput
              formControlName="lastName"
              autocomplete="family-name"
              required>
            </mat-form-field>
            <mat-form-field class="">
              <input type="email"
                placeholder="Email Address"
                aria-label="Email"
                matInput
                formControlName="email"
                autocomplete="email"
                required>
              </mat-form-field>
              <mat-form-field class="">
                <input type="password"
                  placeholder="Password"
                  aria-label="Password"
                  matInput
                  formControlName="password"
                  autocomplete="current-password"
                  required>
                </mat-form-field>
                <mat-checkbox class="text-center mb-4" formControlName="acceptsMarketing">Keep me up to date with My Pool Hut's newsletter</mat-checkbox>
                <button class="accent small-btn" (click)="submit()">
                  @if (!(spinner$ | async)?.show) {
                    Submit
                  }
                  @if ((spinner$ | async)?.show) {
                    <div class="d-flex justify-content-center w-100">
                      <span class="spinner">
                        <ngx-spinner bdColor="rgba(255, 255, 255, 0)" size="small" color="#fff" type="ball-spin-clockwise"
                        [fullScreen]="false"></ngx-spinner>
                      </span>
                    </div>
                  }
                </button>
                <mat-error class="text-center my-2">{{errorMessage}}</mat-error>
              </div>
            </form>
          }
        </div>